const DIRECTUS_URL =
  process.env.REACT_APP_DIRECTUS_URL || "https://admin.tasting-horizons.com";

export function buildUrl(path, params = {}) {
  const url = new URL(`${DIRECTUS_URL}${path}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (typeof value === "object") {
      url.searchParams.set(key, JSON.stringify(value));
    } else {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

export async function getJson(path, params) {
  if (!DIRECTUS_URL) throw new Error("REACT_APP_DIRECTUS_URL is not set");
  const url = buildUrl(path, params);

  // Debug logging for development
  if (process.env.NODE_ENV === "development") {
    console.log("🔍 API Request:", url);
  }

  const res = await fetch(url);
  if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
  const data = await res.json();

  // Debug logging for development
  if (process.env.NODE_ENV === "development") {
    console.log("📦 API Response:", data);
  }

  return data;
}

export function assetUrl(fileId, opts = {}) {
  if (!fileId || !DIRECTUS_URL) return "";
  const url = new URL(`${DIRECTUS_URL}/assets/${fileId}`);

  // Add transformation params
  Object.entries(opts).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "")
      url.searchParams.set(k, String(v));
  });

  // Include static token for asset access if available
  const token = process.env.REACT_APP_DIRECTUS_STATIC_TOKEN;
  if (token) {
    url.searchParams.set("access_token", token);
  }

  return url.toString();
}
